<template>
  <div class="product-info">
    <div class="goodsProfile">
      <img class="goodsPic" :src="product.productImage || errorImg" />
      <div class="goodsInfo">
        <div class="goodsTitle" :title="product.productName">
          {{ product.productName }}
        </div>
        <div class="goodsCode">
          {{ product.productCode }}
        </div>
        <div class="goodsPrice">
          牌价
          <i>￥{{ product.productOriginPrice || product.productPrice }}</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      errorImg: require('../../../../static/img/boxBgImg.svg'),
    };
  },
};
</script>

<style scoped lang="less">
.product-info {
  .goodsProfile {
    overflow: hidden;
    border-bottom: 1px solid #eee;
  }
  .goodsProfile:last-of-type {
    border: none;
  }
  .goodsPic {
    width: 60px;
    height: 60px;
    border: 1px solid #e4e4e4;
    background-color: #f5f5f5;
    float: left;
    box-sizing: border-box;
  }
  .goodsInfo {
    width: calc(100% - 70px);
    height: 60px;
    margin-left: 10px;
    float: right;
  }
  .goodsTitle {
    width: 100%;
    height: 20px;
    font-size: 14px;
    overflow: hidden;
    line-height: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .goodsCode {
    height: 20px;
    font-size: 12px;
    line-height: 11px;
    color: #999999;
  }
  .goodsPrice {
    line-height: 27px;
    i {
      color: #ff6200;
      padding-left: 5px;
      font-weight: 700;
    }
  }
  .goodsUrl {
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
    i {
      color: #3e6ef7;
      font-size: 18px;
      margin-right: 5px;
      display: inline-block;
      vertical-align: middle;
    }
    cursor: pointer;
  }
}
</style>
